var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"tcdnU9FMDXUB6BXfMM-up"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["react-nex@123456-hm"]={id:"tcdnU9FMDXUB6BXfMM-up"};
      